// todo plugin 순서 정리 필요
import { install } from '@backpackr/ids-web'

export default defineNuxtPlugin({
  async setup(nuxtApp) {
    install(nuxtApp.vueApp)
  },
})
